(() => {
  const revealElements = document.querySelectorAll('.ff-reveal');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealElements.forEach((element) => observer.observe(element));
  } else {
    revealElements.forEach((element) => element.classList.add('is-visible'));
  }

  // "Show more" reveals the remaining questions in place rather than sending
  // people off to the old standalone FAQ page.
  const faqSection = document.querySelector('[id*="faq_FbMtBi"]');
  const faqToggle = document.querySelector('[id*="rich_text_ctGWUN"] a.button');

  if (faqSection && faqToggle) {
    const showLabel = faqToggle.textContent.trim();
    const hideLabel = 'Show Less';

    faqToggle.setAttribute('role', 'button');
    faqToggle.setAttribute('aria-expanded', 'false');
    faqToggle.setAttribute('aria-controls', faqSection.id);
    faqToggle.setAttribute('href', `#${faqSection.id}`);

    faqToggle.addEventListener('click', (event) => {
      event.preventDefault();

      const expanded = faqSection.classList.toggle('ff-faq-expanded');

      faqToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      faqToggle.textContent = expanded ? hideLabel : showLabel;

      if (!expanded) {
        faqSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  const logoTrack = document.querySelector('[id*="logo_list_qHA3Hy"] .logo-list');

  if (logoTrack && !logoTrack.dataset.ffCloned) {
    const originals = Array.from(logoTrack.children);

    originals.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
      logoTrack.appendChild(clone);
    });

    logoTrack.dataset.ffCloned = 'true';
  }

  document.querySelectorAll('.shopify-section--header a').forEach((link) => {
    if (link.textContent.trim() === "Elle's Recipes") {
      link.textContent = 'Recipes';
    }
  });

  document.querySelectorAll('[data-ff-hero-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-ff-hero-slide]'));
    const dots = Array.from(gallery.querySelectorAll('[data-ff-hero-dot]'));

    if (slides.length < 2) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = Number(gallery.dataset.interval) || 4000;
    let activeIndex = 0;
    let timer;
    let isVisible = true;

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });
    };

    const stopGallery = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const startGallery = () => {
      stopGallery();
      if (!reduceMotion && isVisible && !document.hidden) {
        timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
      }
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        startGallery();
      });
    });

    if ('IntersectionObserver' in window) {
      const galleryObserver = new IntersectionObserver(([entry]) => {
        isVisible = entry.isIntersecting;
        if (isVisible) startGallery();
        else stopGallery();
      }, { threshold: 0.15 });

      galleryObserver.observe(gallery);
    }

    document.addEventListener('visibilitychange', startGallery);
    startGallery();
  });
})();
